/**
 * Handler: nav_click event
 */

import type { WindowAnalyzify } from '../../types/window-analyzify';
import { gtmMarketFields } from '../utils';

export function handleNavClick(
  analyzify: WindowAnalyzify,
  title: string,
  url: string,
  position: string
): void {
  const win = window as any;

  // GTM — push ee_nav_click (matches v4 an_gtm.js gtmNavClick)
  if (win.dataLayer && analyzify.properties?.GTM?.status) {
    win.dataLayer.push({
      event: 'ee_nav_click',
      ss_event_id: analyzify.eventId.get('nav_click') || null,
      analyzify_source: 'advanced',
      implementation_type: 'extension',
      cart_id: analyzify.cart_id || null,
      nav: { position, type: 'link', title, url },
      ...gtmMarketFields(analyzify),
    });
  }

  // GA4 — fire nav_click via gtag (matches CDN's gaNavClick)
  if (typeof win.gtag === 'function') {
    const props = analyzify.properties;
    if (props?.GA4?.status && props.GA4.primary?.events?.nav_click) {
      win.gtag('event', 'nav_click', {
        send_to: props.GA4.primary.id,
        nav: { position, type: 'link', title, url },
      });
    }
    if (props?.GA4?.secondary?.status && props.GA4.secondary?.events?.nav_click) {
      win.gtag('event', 'nav_click', {
        send_to: props.GA4.secondary.id,
        nav: { position, type: 'link', title, url },
      });
    }
  }

  analyzify.log(`Nav click tracked: ${title} → ${url} (${position})`, 'dispatcher');
}
